import { render, staticRenderFns } from "./SalesSilp.vue?vue&type=template&id=e4d7d0bc&scoped=true"
import script from "./SalesSilp.vue?vue&type=script&lang=ts"
export * from "./SalesSilp.vue?vue&type=script&lang=ts"
import style0 from "./SalesSilp.vue?vue&type=style&index=0&id=e4d7d0bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4d7d0bc",
  null
  
)

export default component.exports